<form
  class="cancel-order-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <p class="cancel-order-intro">
    Vas a cancelar el pedido <strong>{{ orderCode }}</strong>. Elige el motivo: queda guardado en
    el pedido.
  </p>

  <div class="form-group">
    <span class="form-label is-required">Motivo</span>
    <div class="reason-options" role="radiogroup">
      @for (option of reasonOptions; track option) {
        <label class="reason-option">
          <input type="radio" formControlName="reasonOption" [value]="option" />
          <span>{{ option }}</span>
        </label>
      }
      <label class="reason-option">
        <input type="radio" formControlName="reasonOption" [value]="otherOptionValue" />
        <span>Otro</span>
      </label>
    </div>
    @if (reasonOptionInvalid) {
      <span class="form-error">Elige un motivo.</span>
    }
  </div>

  @if (isOtherSelected) {
    <div class="form-group">
      <label class="form-label is-required" for="custom-reason">Detalle</label>
      <textarea
        id="custom-reason"
        class="form-input"
        formControlName="customReason"
        rows="3"
        placeholder="Ej: el cliente pensó que venían dos piezas y es solo una"
      ></textarea>
      @if (customReasonInvalid) {
        <span class="form-error">Describe qué pasó.</span>
      }
    </div>
  }

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Volver
    </button>
    <button type="submit" class="btn btn-primary">
      Confirmar cancelación
    </button>
  </div>
</form>
